import { Create } from "@/components/admin/create";
import { SimpleForm } from "@/components/admin/simple-form";
import { useGetIdentity, useGetOne } from "ra-core";
import { useSearchParams } from "react-router";
import { TransactionInputs } from "./TransactionInputs";
import type { Transaction } from "../../types";

export const TransactionCreate = () => {
  const { identity } = useGetIdentity();
  const [searchParams] = useSearchParams();
  const duplicateFromId = searchParams.get("duplicate_from");
  const { data: source, isPending: sourceLoading } = useGetOne<Transaction>(
    "transactions",
    { id: duplicateFromId! },
    { enabled: !!duplicateFromId },
  );

  // Wait for source data when duplicating to avoid resetting form values
  if (duplicateFromId && sourceLoading) return null;

  const direction = source?.direction ?? searchParams.get("direction") ?? "expense";

  const defaultValues = source
    ? {
        sales_id: identity?.id,
        direction: source.direction,
        amount: source.amount,
        account_id: source.account_id,
        category_id: source.category_id ?? undefined,
        contract_id: source.contract_id ?? undefined,
        deal_id: source.deal_id ?? undefined,
        company_id: source.company_id ?? undefined,
        description: source.description ?? undefined,
        occurred_at: new Date().toISOString().slice(0, 10),
      }
    : {
        sales_id: identity?.id,
        direction,
        amount: 0,
        occurred_at: new Date().toISOString().slice(0, 10),
        account_id: searchParams.get("account_id") ?? undefined,
        contract_id: searchParams.get("contract_id") ?? undefined,
      };

  return (
    <Create mutationMode="pessimistic" redirect="list">
      <SimpleForm className="max-w-3xl" defaultValues={defaultValues}>
        <TransactionInputs />
      </SimpleForm>
    </Create>
  );
};
